import { FC } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";

interface Props {
  title: string;
  description?: string;
  onClose: () => void;
  onSubmit: () => void;
  submitButtonText?: string;
  closeButtonText?: string;
}

export const ConfirmModal: FC<Props> = ({
  title,
  description,
  onClose,
  onSubmit,
  submitButtonText = "Áno",
  closeButtonText = "Zatvoriť",
}) => (
  <Modal isOpen onClose={onClose}>
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>{title}</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <Text>{description}</Text>
      </ModalBody>
      <ModalFooter>
        <Button
          colorScheme="blue"
          mr={3}
          onClick={onClose}
          variant="transparent"
        >
          {closeButtonText}
        </Button>
        <Button variant="error" onClick={onSubmit}>
          {submitButtonText}
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
